(() => {
  if (window.cf31Arena) { window.cf31Arena.mount(document); return; }
  const controllers = new Map();
  function mount(scope) {
    scope.querySelectorAll('[data-cf31-arena]').forEach(root => {
      if (controllers.has(root)) return;
      const controller = new AbortController();
      controllers.set(root, controller);
      const cards = [...root.querySelectorAll('[data-arena-format]')];
      const buttons = [...root.querySelectorAll('[data-arena-filter]')];
      function filter(value) {
        if (!['all', 'player', 'team', 'random', 'ten-spots'].includes(value)) return;
        let visible = 0;
        cards.forEach(card => {
          card.hidden = value !== 'all' && card.dataset.arenaFormat !== value;
          if (!card.hidden) visible++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.arenaFilter === value)));
        root.querySelector('[data-arena-count]').textContent = `${visible} break${visible > 1 ? 's' : ''} dans cette sélection`;
        root.querySelector('[data-arena-empty]').hidden = !cards.length || visible > 0;
      }
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-arena-filter]');
        if (button && root.contains(button)) filter(button.dataset.arenaFilter);
      }, {signal: controller.signal});
      filter('all');
    });
  }
  window.cf31Arena = {mount};
  mount(document);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cf31-format]');
    if (!link) return;
    const arena = document.getElementById('cf31-arena');
    const button = arena?.querySelector(`[data-arena-filter="${link.dataset.cf31Format}"]`);
    if (!button) return;
    event.preventDefault();
    button.click();
    arena.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    button.focus({preventScroll:true});
  });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, root) => {
      if (event.target.contains(root)) { controller.abort(); controllers.delete(root); }
    });
  });
})();
